module.exports = __webpack_public_path__ + "static/media/redness.74e5a3c8.svg";